import React from "react";
import {Text} from "atoms"
import {isMobile} from "react-device-detect";
import "./styles.scss";

export default props => (
  <div className="promotion-headline">
    {isMobile ? 
      <Text h2 left text={props.headlineTitle}/> :
      <Text h2 right text={props.headlineTitle}/>
    }
    <div className="title-container">
      <Text p text={props.headlineText}/>
      <img src={props.image} alt={props.imageAlt}/>
    </div>
    <div className="features-container">
      {props.children}
    </div>
  </div>
);
